export const oktaDefaultConfig = {
  issuer: "https://dev-48286076.okta.com/oauth2/default", // This is a dummy setup for having the useOktaAuth hook working before knowing client info
  clientId: "0oan2fj0zhKasUF095d7", // This is a dummy setup for having the useOktaAuth hook working before knowing client info
  redirectUri: window.location.origin + "/callback",
  scopes: ["openid", "profile", "email"],
  pkce: true,
};
